export const UPDATE_TUB_INDEX = 'UPDATE_STEP_INDEX';

export const updateTubIndex = tubIndex => ({
  type: UPDATE_TUB_INDEX,
  index: tubIndex,
});
